export default __webpack_public_path__ + "static/media/virtualpad_bt_y.d0fab918.png";